import axios from 'axios';
import store, { history } from '../../store';

import { sofologistLogout } from '../../actions/sofologist';

/** globally handle responses from this instance
 *
 * CASES
 *   * ALL other responses pass on response
 *
 * @param { Object } response httpResponse object from interceptor
 *
 * @returns { Object } httpResponse object from interceptor
 */
function handleResponse(response) {
  return response;
}

/** globally handle response errors from interceptor
 *
 * CASES
 *   * 401 Unauthorised errors wipe local auth and redirect to admin login
 *   * ALL other errors pass promise rejection on
 *
 * @param { Object } error httpResponse object from error interceptor
 *
 * @returns { Promise<Object> } promise rejection passing along httpResponse error.
 */
function handleError(error) {
  if(error.response && error.response.status === 401) {
    store.dispatch(sofologistLogout());
    history.push('/admin');
  }
  return Promise.reject(error);
}

const instance = axios.create({});
instance.interceptors.response.use(handleResponse, handleError);

/** provide axios proxy for calling mysofology as a sofologist
 *
 * NB: for some reason axios is sharing default headers accross instances, this works around it
 *
 */
export default {
  get: url => instance.get(url, { headers: { Authorization: `Bearer ${store.getState().sofologist.token}` } }),
  post: (url, body) => instance.post(url, body, { headers: { Authorization: `Bearer ${store.getState().sofologist.token}` } }),
  delete: url => instance.delete(url, { headers: { Authorization: `Bearer ${store.getState().sofologist.token}` } })
};



// WEBPACK FOOTER //
// ./src/services/dataSources/asSofologist.js